import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import data from '../../data/contact';
import { useLanguage } from '../LanguageContext';

const ContactIcons = () => {
  const { lang } = useLanguage();

  return (
    <div className="contact-icons-container">
      <ul className="icons">
        {data.map((s) => (
          <li key={s.label}>
            <a href={typeof s.link === 'function' ? s.link(lang) : s.link} aria-label={s.label}>
              <FontAwesomeIcon icon={s.icon} />
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ContactIcons;
